export const Code = {
  SelectBranch: "Select branch",
  SearchBranch: "Search branch",
  NoBranchFound: "No branch found.",
  SelectRepository: "Select repository",
  SearchRepository: "Search repository",
  NoRepositoryFound: "No repository found."
}
